import React, { useMemo, useState } from 'react'
import { Badge, RecordList } from '../BusinessDetailReport/BusinessDetailReport'
import styles from '../BusinessDetailReport/BusinessDetailReport.module.scss'
import { buildPersonalInfo } from './personalInfoModel'

const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`
const PREVIEW = 6

export const InlineList = ({ label, items }) => {
    const [all, setAll] = useState(false)
    if (!items.length) return null
    return (
        <div className={styles.inlineList}>
            <strong>{label}:</strong> {(all ? items : items.slice(0, PREVIEW)).join(' · ')}
            {items.length > PREVIEW && (
                <> <button type='button' className={styles.textButton} onClick={() => setAll(v => !v)}>{all ? 'Show fewer' : `Show all (${items.length})`}</button></>
            )}
        </div>
    )
}

export default function PersonalInfo({ person, showSummary = true }) {
    const model = useMemo(() => buildPersonalInfo(person), [person])
    if (!model.hasData) return <div className={styles.calmLine}>No personal information in this report.</div>

    return (
        <div className={styles.uccList}>
            <div className={styles.uccLender}>{model.name}</div>
            <dl className={`${styles.uccDetails} ${styles.flushDetails}`}>
                {model.facts.map(f => <React.Fragment key={f.label}><dt>{f.label}</dt><dd>{f.value}</dd></React.Fragment>)}
            </dl>
            {showSummary && (model.chips.length > 0 || model.confirmed) && (
                <div className={styles.inlineBadges}>
                    {model.chips.map(c => <Badge key={c.label} tone={c.tone} dot={c.tone === 'declined'}>{c.label}</Badge>)}
                    {model.confirmed && <Badge tone='neutral'>{model.confirmed}</Badge>}
                </div>
            )}

            <InlineList label={plural(model.aliases.length, 'other name')} items={model.aliases} />

            {model.licenses.length > 0 && (
                <>
                    <div className={styles.uccGroupTitle}>{plural(model.licenses.length, "driver's license")}</div>
                    <RecordList items={model.licenses} />
                </>
            )}
            {model.phones.length > 0 && (
                <>
                    <div className={styles.uccGroupTitle}>{plural(model.phones.length, 'phone')}</div>
                    <RecordList items={model.phones} />
                </>
            )}
            <InlineList label={plural(model.emails.length, 'email')} items={model.emails} />
            {model.more.map(block => (
                <div key={block.details[0].label} className={styles.detailBlock}>
                    <div className={styles.detailBlockTitle}>{block.title}</div>
                    <dl className={styles.uccDetails}>
                        {block.details.map(d => <React.Fragment key={d.label}><dt>{d.label}</dt><dd>{d.value}</dd></React.Fragment>)}
                    </dl>
                </div>
            ))}
        </div>
    )
}
